import React from 'react';
import { PerformanceTableSkeleton } from './components/PerformanceTableSkeleton/PerformanceTableSkeleton';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  onRetry?(): void;
}

export const PerformanceDetailsError: React.FC<Props> = ({ onRetry }) => {
  return (
    <PerformanceTableSkeleton>
      <Box p="56" bg="bg">
        <ErrorState onAction={onRetry} />
      </Box>
    </PerformanceTableSkeleton>
  );
};
